import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGood = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 48.6587,
			cy: 43.4495,
			r: 8.44969,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 79.0766,
			cy: 43.4495,
			r: 8.44969,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.1396 54.5503C35.1396 70.4169 48.002 83.2792 63.8686 83.2792C79.7351 83.2792 92.5975 70.4169 92.5975 54.5503H102.737C102.737 76.0168 85.3351 93.4189 63.8686 93.4189C42.4021 93.4189 25 76.0168 25 54.5503H35.1396Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgGood);
export default ForwardRef;
